const BASE = process.env.REACT_APP_API_URL; //"https://hob-backend.vercel.app/api";

const getToken = () => localStorage.getItem("hobAdminToken");

async function request(path, options = {}) {
  const token = getToken();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  console.log(res);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    // Only redirect on 401 for non-auth routes (not the login call itself)
    if (res.status === 401 && !path.includes("/auth/")) {
      localStorage.removeItem("hobAdminToken");
      //window.location.href = "/admin";
    }
    throw new Error(err.error || "Request failed");
  }
  return res.json();
}

// ── Auth ───────────────────────────────────────────────────────────────────
export const authApi = {
  login: (data) =>
    request("/auth/login", { method: "POST", body: JSON.stringify(data) }),
};

// ── Contact ────────────────────────────────────────────────────────────────
export const contactApi = {
  submit: (data) =>
    request("/contact", { method: "POST", body: JSON.stringify(data) }),
};

// ── Admin Users ────────────────────────────────────────────────────────────
export const adminUsersApi = {
  getAll: () => request("/admin/users"),
  create: (data) =>
    request("/admin/users", { method: "POST", body: JSON.stringify(data) }),
  update: (id, data) =>
    request(`/admin/users/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),
  remove: (id) => request(`/admin/users/${id}`, { method: "DELETE" }),
};

// ── Members ──────────────────────────────────────────────────────────────────
export const memberApi = {
  getAll: () => request("/members"),
  // create: (data) =>
  //   request("/blogs", { method: "POST", body: JSON.stringify(data) }),
  // update: (id, data) =>
  //   request(`/blogs/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  remove: (id) => request(`/members/${id}`, { method: "DELETE" }),
};

// ── Reservation ──────────────────────────────────────────────────────────
export const reservationApi = {
  getAll: () => request("/reservations"),
  // create: (data) =>
  //   request("/news-events", { method: "POST", body: JSON.stringify(data) }),
  // update: (id, data) =>
  //   request(`/news-events/${id}`, {
  //     method: "PUT",
  //     body: JSON.stringify(data),
  //   }),
  remove: (id) => request(`/reservations/${id}`, { method: "DELETE" }),
};

// ── Career ──────────────────────────────────────────────────────────
export const careerApi = {
  getAll: () => request("/getalljobrequest"),
  // create: (data) =>
  //   request("/news-events", { method: "POST", body: JSON.stringify(data) }),
  // update: (id, data) =>
  //   request(`/news-events/${id}`, {
  //     method: "PUT",
  //     body: JSON.stringify(data),
  //   }),
  remove: (id) => request(`/reservations/${id}`, { method: "DELETE" }),
};
